import { ApiFormattedResponse } from "@models/api_formatted_response"
import { mutate } from "@utils/graphql"
import {
  DeletePlatformTypeInput,
  OPlatformResponse,
  PlatformType,
  PlatformsResponse,
  UpdatePlatformInputData
} from "__generated__/graphql"
import deletePlatform from "__generated__/queries/mutations/deletePlatform"
import updatePlatform from "__generated__/queries/mutations/updatePlatform"
import findAllPlatformQuery from "__generated__/queries/queries/findAllPlatformQuery"

type ResponseData = {
  data: string
}

export async function getWhatsappApiPlatform(data: {
  search?: string
}): Promise<ApiFormattedResponse<ResponseData>> {
  const response = await mutate<{
    findAllPlatformQuery?: PlatformsResponse
  }>({
    mutation: findAllPlatformQuery,
    variables: {
      metaData: {
        ...(data.search && { search: data.search })
      },
      type: "WHATS_APP_BUSINESS"
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: {
      data: response?.data?.findAllPlatformQuery?.data as unknown as string
    }
  }
}

export async function updatePlatforms(data: {
  type: PlatformType
  metaData: UpdatePlatformInputData
}): Promise<ApiFormattedResponse<ResponseData>> {
  const response = await mutate<{
    updatePlatform?: OPlatformResponse
  }>({
    mutation: updatePlatform,
    variables: {
      metaData: data.metaData,
      type: data.type
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: { data: response?.data?.updatePlatform?.data as string }
  }
}

export async function deletePlatformMutation(data: {
  type: PlatformType
  metaData: DeletePlatformTypeInput
}): Promise<ApiFormattedResponse<ResponseData>> {
  const response = await mutate<{
    deletePlatform?: OPlatformResponse
  }>({
    mutation: deletePlatform,
    variables: {
      metaData: data.metaData,
      type: data.type
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: { data: response?.data?.deletePlatform?.data as string }
  }
}
